import React, { Fragment } from 'react'
import Icon from './icon'
import './picker.css'
import calendar from 'calendar-month-array'

/**
 * DatePicker
 */
const DatePicker = class extends React.Component {

    static defaultProps = {
        year : 2018,
        month: 11,
        day  : 10,
    }

    state = {
        year : this.props.year,
        month: this.props.month,
        day  : this.props.day,
    }

    changeYear = (year) => {
        this.setState({ year })
    }

    changeMonth = (nextMonth) => {
        const month = nextMonth === 0 ? 12 : nextMonth === 13 ? 1 : nextMonth
        const year  = nextMonth === 0 ? this.state.year -1 :
                      nextMonth === 13 ? this.state.year + 1 : this.state.year
        this.setState({ month, year })
    }

    changeDay = (day) => {
        this.setState({ day })
        this.fireChange({ day, month: this.state.month, year: this.state.year })
    }

    fireChange = (date) => {
        const { onChange, formatter } = this.props
        const value = formatter ? formatter(date) : date
        if (onChange) onChange(value)
    }

    render() {

        const { today = true } = this.props

        const weeks = calendar(new Date(this.state.year, this.state.month - 1 ),{
            weekStartDay: 1,
            formatDate: date => date.getDate(),
            formatSiblingMonthDate: () => ' '
        }).flat()

        return (
            <div className="date-picker" >
                <header>
                    <YearPicker year={this.state.year} onChange={this.changeYear}/>
                    {today ? <DateName day={this.state.day} month={this.state.month} year={this.state.year} /> : '' }
                </header>
                <main>
                    <MonthPicker month={this.state.month} onChange={this.changeMonth} />
                    <Weeks weeks={weeks} selected={this.state.day} onSelect={this.changeDay} events={this.props.events}/>
                </main>
            </div>
        )
    }
}

/**
 * YearPicker
 */
const YearPicker = ({ year, onChange }) => {
    return (
        <div className="year-picker">
            <Icon icon="chevron_left" clickable small className="square" action={() => onChange(year-1)} />
            <div className="year">{year}</div>
            <Icon icon="chevron_right" clickable small className="square" action={() => onChange(year+1)} />
        </div>
    )
}

/**
 * MonthPicker
 */
const MonthPicker = ({ month, onChange }) => {
    const date = new Date(`${month}/1/2018`)
    const monthName = date.toLocaleString("es-ES", { month: 'long' })
    return (
        <div className="month-picker">
            <Icon icon="chevron_left" clickable small className="square" action={() => onChange(month-1)} />
            <div className="month">{monthName}</div>
            <Icon icon="chevron_right" clickable small className="square" action={() => onChange(month+1)} />
        </div>
    )
}

/**
 * Weeks
 */
const Weeks = ({ weeks = [], selected, events = [], onSelect }) => {
    return (
        <div className="weeks">
            <span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span>
            { weeks.map( day => {
                const selection = day === selected ? 'selected' : ''
                const busy =  events.some( event => event === day) ? 'busy' : ''
                return day === ' ' ?
                    <span></span>
                    :
                    <button className={`${selection} ${busy}`} onClick={() => onSelect(day)}><span>{day}</span></button>
            })}
        </div>
    )
}

const DateName = ({ day, month, year }) => {
    const date = new Date(`${month}/${day}/${year}`)
    const monthName = date.toLocaleString("es-ES", { month: 'long' })
    const dayName = date.toLocaleString("es-ES", { weekday: 'long' })
    return (
        <div className="dateName">
            <span className="day-name">{dayName},</span>
            <span className="day">&nbsp;{day}</span>
            <span className="month-name">&nbsp;{monthName}</span>
            <span className="year">&nbsp;{year}</span>
        </div>
    )
}

export { DatePicker }



// WEBPACK FOOTER //
// ./src/lib/components/picker.js